<template>
  <div>
    <div class="row" v-if="[2,3,4].includes(logged_in_user.group_id)">
      <div class="col-12">
        <router-link :to="{ name:'AdminBarionetAdd' }" class="btn btn-success"><i class="fa fa-edit" aria-hidden="true"></i>
          Add Barionet Device
        </router-link>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-12">
        <table class="table table-striped">
          <thead class="bg-hub-primary text-white">
          <tr>
            <th></th>
            <th><a @click="sortBy('name')">Name</a></th>
            <th><a @click="sortBy('ip')">IP</a></th>
            <th class="d-none d-md-table-cell">Port</th>
            <th>Manage</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="device in filtered_devices" :key="device.device_id">
            <td v-if="device.online"><i class="fa fa-check-circle online" aria-hidden="true"></i></td>
            <td v-else><i class="fa fa-times-circle offline" aria-hidden="true"></i></td>
            <td>{{ device.name }}</td>
            <td><a :href="'http://' + device.ip" target="_blank">{{ device.ip }}</a></td>
            <td class="d-none d-md-table-cell">{{device.port}}</td>
            <td>
              <div class="dropdown">
                <button class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fa fa-cogs fa-fw" aria-hidden="true"></i>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <router-link :to="{ name:'AdminBarionetEdit', params: { device_id: device.device_id } }"
                               class="dropdown-item" v-if="[2,3,4].includes(logged_in_user.group_id)"><i
                    class="fa fa-pencil-alt fa-fw" aria-hidden="true"></i>&nbsp;Edit
                  </router-link>
                  <a class="dropdown-item" href="#" onclick="return false" @click="deleteDevice(device)"
                     v-if="[2,3,4].includes(logged_in_user.group_id)"><i
                    class="fa fa-trash fa-fw" aria-hidden="true"></i>&nbsp;Delete</a>
                  <div class="dropdown-divider" v-if="[2,3,4].includes(logged_in_user.group_id)"></div>
                  <a class="dropdown-item" :href="'http://' + device.ip + '/rc.cgi?o=1,0'" target="_blank">Open Relay 1</a>
                  <a class="dropdown-item" :href="'http://' + device.ip + '/rc.cgi?o=1,1'" target="_blank">Close Relay 1</a>
                  <div class="dropdown-divider" v-if="[2,3,4].includes(logged_in_user.group_id)"></div>
                  <a class="dropdown-item" :href="'http://' + device.ip + '/rc.cgi?o=2,0'" target="_blank">Open Relay 2</a>
                  <a class="dropdown-item" :href="'http://' + device.ip + '/rc.cgi?o=2,1'" target="_blank">Close Relay 2</a>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'devices',
  computed: {
    ...mapGetters({
      devices: 'allDevices',
      command_result: 'commandResult',
      logged_in_user: 'loggedInUser',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_devices: function () {
      return this.devices.filter(device => device.device_type_id === 4 && device.site_id === this.scoped_site_id)
    }
  },
  watch: {
    command_result: function (val) {
      alert(val)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', false)
    this.$store.dispatch('getDevices')
  },
  methods: {
    ...mapActions([
      'deleteDevice'
    ]),
    apply () {
      this.$store.dispatch('executeCommand', '2')
    },
    sortBy (sortBy) {
      this.$store.dispatch('sortDevices', sortBy)
    }
  }
}
</script>

<style scoped>
  .online {
    color: green;
  }

  .offline {
    color: red;
  }

  .registered {
    font-weight: bold;
    color: green;
  }

  .not-registered {
    font-weight: bold;
    color: red;
  }
</style>
